import React from 'react';

import useProductAttributes from 'data-hooks/useProductAttributes/index';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPDimensionsAndDetailsUI from './PDPDimensionsAndDetailsUI';

const PDPDimensionsAndDetailsInner = () => {
  const {
    loading,
    error,
    data: { dimensions },
  } = useProductAttributes();

  if (error) {
    return <div className="PDPDimensionsAndDetails__filler-error" />;
  }

  // render only if the product has dimensions
  return dimensions?.length ? (
    <PDPDimensionsAndDetailsUI loading={loading} />
  ) : (
    <div className="PDPDimensionsAndDetails__filler-loading" />
  );
};

const PDPDimensionsAndDetails = props => (
  <SuspenseWithLoader>
    <PDPDimensionsAndDetailsInner {...props} />
  </SuspenseWithLoader>
);

export default PDPDimensionsAndDetails;
